// material-ui
import { useTheme } from '@mui/material/styles';
// project imports
import { ThemeMode } from 'config';
import logo from 'assets/images/signup-logo.svg';
import wordmarkOnDark from 'assets/images/netgear-insight.png';

const DIAMOND_TEAL = '#1CB9A0';
const DIAMOND_GREEN = '#26E880';

// ==============================|| SIGNUP / ACCOUNT-PICKER LOGO ||============================== //

export default function SignupLogo() {
  const theme = useTheme();
  const isDark = theme.palette.mode === ThemeMode.DARK;

  if (!isDark) {
    return <img src={logo} alt="Signup Logo" style={{ width: '250px' }} />;
  }

  // signup-logo.svg embeds a navy (#2B3749) wordmark and diamond facet that disappear on
  // dark backgrounds. Rebuild the mark with the white wordmark used in the dashboard header.
  return (
    <svg
      width="250"
      height="55"
      viewBox="0 0 233 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Signup Logo"
    >
      <path
        d="M51.4292 50.6121L44.0804 37.959H29.3889V37.962V37.959H14.6943L22.0401 50.6121H36.7346H51.4292Z"
        fill={DIAMOND_TEAL}
      />
      <path
        d="M22.0403 25.3054L29.3891 12.6523H14.6946L7.34575 25.3054H7.35186H7.34575L0 37.9585H14.6946L22.0403 25.3054H22.0373H22.0403Z"
        fill={DIAMOND_GREEN}
      />
      <path
        d="M51.429 25.3062L44.0802 12.6531L36.7344 0L29.3887 12.6531H29.3917H29.3887L36.7344 25.3062H36.7405H36.7344L44.0802 37.9593L51.429 25.3062H51.4229H51.429Z"
        fill="#FFFFFF"
      />
      <image href={wordmarkOnDark} x="65" y="10" width="124" height="30" />
    </svg>
  );
}
